import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { knowledgeAPI } from "../../services/api";
import KnowledgeCard from "../knowledge/KnowledgeCard";
import { motion } from "framer-motion";

const KnowledgeSection = () => {
  const [knowledge, setKnowledge] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchKnowledge = async () => {
      try {
        console.log("Fetching recent knowledge...");
        const response = await knowledgeAPI.getRecent(8);
        console.log("Full API Response:", response);
        console.log("Response data:", response.data);

        // ตรวจสอบโครงสร้าง response หลายแบบ
        if (response.data) {
          // แบบที่ 1: { success: true, data: [...] }
          if (
            response.data.success === true &&
            Array.isArray(response.data.data)
          ) {
            console.log("Using format 1: success/data");
            setKnowledge(response.data.data);
          }
          // แบบที่ 2: response.data เป็น array โดยตรง
          else if (Array.isArray(response.data)) {
            console.log("Using format 2: direct array");
            setKnowledge(response.data);
          }
          // แบบที่ 3: response.data.data เป็น array
          else if (response.data.data && Array.isArray(response.data.data)) {
            console.log("Using format 3: nested data");
            setKnowledge(response.data.data);
          }
          // แบบที่ 4: response.data.result เป็น array
          else if (
            response.data.result &&
            Array.isArray(response.data.result)
          ) {
            console.log("Using format 4: result array");
            setKnowledge(response.data.result);
          } else {
            console.error("Unknown response format:", response.data);
            setError("รูปแบบข้อมูลไม่ถูกต้อง");
          }
        } else {
          setError("ไม่ได้รับข้อมูลจากเซิร์ฟเวอร์");
        }
      } catch (error) {
        console.error("Failed to fetch knowledge:", error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchKnowledge();
  }, []);

  // Debug: แสดง knowledge ที่ได้
  useEffect(() => {
    console.log("Current knowledge state:", knowledge);
  }, [knowledge]);

  if (loading) {
    return (
      <section className="py-16 bg-gray-50">
        <div className="container-custom">
          <div className="flex justify-center">
            <div className="spinner"></div>
          </div>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className="py-16 bg-gray-50">
        <div className="container-custom text-center">
          <p className="text-red-500">เกิดข้อผิดพลาด: {error}</p>
          <button
            onClick={() => window.location.reload()}
            className="mt-4 px-4 py-2 bg-primary-500 text-white rounded-lg hover:bg-primary-600"
          >
            ลองใหม่อีกครั้ง
          </button>
        </div>
      </section>
    );
  }

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center mb-8">
          <h1
            className="text-3xl md:text-4xl font-bold text-primary-500 relative"
            style={{
              paddingBottom: "1rem",
              borderBottom: "3px solid #FFBF07",
              width: "fit-content",
            }}
          >
            <i className="fas fa-brain mr-2 text-secondary-500"></i>
            องค์ความรู้ล่าสุด
          </h1>

          <Link
            to="/knowledge"
            className="btn-primary inline-flex items-center gap-2"
          >
            ดูทั้งหมด
            <i className="fas fa-arrow-right"></i>
          </Link>
        </div>

        {knowledge && knowledge.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {knowledge.map((item, index) => (
              <motion.div
                key={item.knowledge_id || index}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
              >
                <KnowledgeCard knowledge={item} />
              </motion.div>
            ))}
          </div>
        ) : (
          <div className="text-center py-12 bg-white rounded-lg">
            <i className="fas fa-book-open text-4xl text-gray-300 mb-3"></i>
            <p className="text-gray-500">ยังไม่มีองค์ความรู้ในขณะนี้</p>
          </div>
        )}
      </div>
    </section>
  );
};

export default KnowledgeSection;
